import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { userStatsFetchStateConfig } from "../../../../consts";

export const userStatsMeta = makeCrudStateReducer(userStatsFetchStateConfig);
